import {
  Participant,
  ParticipantServerData,
  Speaker,
  SpeakerServerData,
  TeamType,
} from '@typings/participant';
import { User } from '@typings/user';

export const participantsMapper = (
  participants: ParticipantServerData[] = [],
  showId: string,
  speakers?: SpeakerServerData[],
) => {
  const participantsData: Record<string, Participant> = {};
  const usersData: Record<string, User> = {};
  const speakersData: Record<string, Speaker> = {};
  let rightTeamSpeakerId: string | null = null;
  let leftTeamSpeakerId: string | null = null;

  const participantIds = participants.map((participant) => {
    const { id, profile, ...restParticipant } = participant;
    participantsData[id] = {
      ...restParticipant,
      id,
      profileId: profile.id,
      showId,
    };

    usersData[profile.id] = {
      ...profile,
    };

    return participant.id;
  });

  if (speakers && speakers.length) {
    speakers.forEach((speaker) => {
      if (speaker && speaker.endedAt === null) {
        speakersData[speaker.id] = {
          id: speaker.id,
          side: speaker.side,
          likesCount: 0,
          profileId: speaker.user.id,
          topicId: speaker.topic?.id,
          participantId: speaker.participant?.id,
          createdAt: speaker.createdAt,
        };

        switch (speaker.side) {
          case TeamType.Blue:
            leftTeamSpeakerId = speaker.id;
            break;
          case TeamType.Red:
            rightTeamSpeakerId = speaker.id;
            break;
          default:
            break;
        }
      }
    });
  }

  return {
    participantIds,
    participantsData,
    usersData,
    rightTeamSpeakerId,
    leftTeamSpeakerId,
    speakersData,
  };
};

export const topUsersMapper = (tops: { user: User; likesCount: number }[]) => {
  const usersData: Record<string, User> = {};
  const topUsersList = tops.map((top) => {
    usersData[top.user?.id] = { ...top.user };
    return {
      userId: top.user?.id,
      likesCount: top.likesCount || 0,
    };
  });
  return {
    usersData,
    topUsersList,
  };
};
